const colors = {
	white: "#ffffff",
	black: "#000000",
	darkGreen: "#013220",
	shyTomato: "#c91432",
	brown: "#a52a2a",
	lightGray: "#f5f5f5",
}

export default colors;